<template>
    <div class="container-box">
        <div class="container-box-top">
            <div class="_head">
                <h1>{{ $t('assets.futures_account') }}</h1>
                <div class="button-group">
                    <a-button type="primary" class="button" @click="$emit('topup')">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg" class="">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M6 3C6 2.44772 6.44772 2 7 2H9C9.55229 2 10 2.44772 10 3V6H11.0073C11.864 6 12.3241 7.00701 11.7632 7.65465L8.75593 11.1271C8.35716 11.5876 7.64284 11.5876 7.24407 11.1271L4.23682 7.65465C3.67594 7.00701 4.136 6 4.99275 6H6V3ZM4 12C3.44772 12 3 12.4477 3 13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12H4Z"
                                  fill="var(--content-white)">
                            </path>
                        </svg>
                        {{ $t('assets.deposit') }}
                    </a-button>
                    <a-button class="button" @click="withdrawShow = true">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg" class="">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M10 13C10 13.5523 9.55228 14 9 14L7 14C6.44771 14 6 13.5523 6 13L6 10L4.99275 10C4.136 10 3.67594 8.99299 4.23682 8.34535L7.24407 4.87287C7.64284 4.41241 8.35716 4.41241 8.75593 4.87287L11.7632 8.34535C12.3241 8.99299 11.864 10 11.0072 10L10 10L10 13ZM12 4C12.5523 4 13 3.55229 13 3C13 2.44771 12.5523 2 12 2L4 2C3.44772 2 3 2.44771 3 3C3 3.55228 3.44772 4 4 4L12 4Z"
                                  fill="var(--content-primary)">
                            </path>
                        </svg>
                        {{ $t('assets.withdraw') }}
                    </a-button>
                    <a-button class="button" @click="transfeShow = true">
                        <svg  width="16" height="16" viewBox="0 0 16 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg" class="">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M2.26949 5.29583C1.64358 5.92699 2.09065 6.99998 2.97954 6.99998L5.39787 6.99998H13.0008C13.5531 6.99998 14.0008 6.55226 14.0008 5.99998C14.0008 5.44769 13.5531 4.99998 13.0008 4.99998H7.52129V2.42852C7.52129 1.5356 6.43998 1.09035 5.81124 1.72437L2.26949 5.29583Z"
                                  fill="var(--content-primary)"></path>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M13.7081 10.7042C14.334 10.073 13.8869 9.00002 12.998 9.00002L10.5797 9.00002L8.45625 9.00002L2.97672 9.00002C2.42444 9.00002 1.97672 9.44774 1.97672 10C1.97672 10.5523 2.42444 11 2.97672 11L8.45625 11L8.45625 13.5715C8.45625 14.4644 9.53756 14.9096 10.1663 14.2756L13.7081 10.7042Z"
                                  fill="var(--content-primary)">
                            </path>
                        </svg>
                        {{ $t('assets.transfer') }}
                    </a-button>
                </div>
            </div>
            <div class="asset-all">
                <div class="_t">
                    <span>{{ $t('assets.total') }}</span>
                    <div @click="visual = !visual">
                        <icon-eye-invisible v-if="visual" class="color-gray" size="16"/>
                        <icon-eye v-else class="color-gray" size="16"/>
                    </div>
                </div>
                <p class="price">
                    {{ visual ? '********' : (total ? total : '0.00000000') }} USDT
                </p>
                <p class="convert">
                    ≈ {{symbol}} {{ visual ? '********' : $util.formatFiat(total, symbol_rate, 2) }}
                </p>
            </div>
        </div>
        <!--总览-->
        <div class="content-main-bottom">
            <div class="btm-left flex flex-column align-start">
                <div class="flex align-center jus-bet btm-left-head">
                    <div class="flex align-center">
                        <span class="font-20 color-black font-bold mr-10">{{ $t('assets.fund_list') }}</span>
                        <a-checkbox value="1" @change="checkboxChange">
                            <span class="font-12 color-gray">{{ $t('assets.hide_zero_assets') }}</span>
                        </a-checkbox>
                    </div>
                    <div>
                        <a-input class="search" v-model="search" :placeholder="$t('assets.search_currency')">
                            <template #prefix>
                                <icon-search/>
                            </template>
                        </a-input>
                    </div>
                </div>
                <!--        -->
                <div class="list">
                    <div>
                        <div class="tab">
                            <span>{{ $t('assets.coin') }}</span>
                            <span>{{ $t('assets.total') }}</span>
                            <span>{{ $t('assets.available') }}</span>
                            <span>{{ $t('assets.frozen') }}</span>
                            <span>{{ $t('assets.asset_conversion') }}</span>
                            <span>{{ $t('assets.operation') }}</span>
                        </div>
                        <div class="cell flex align-center jus-bet" v-for="(item,idx) in list" :key="idx">
                            <div class="cell-item">
                                <div class="flex align-center">
                                    <img class="coin-icon" :src="item.icon">
                                    <span class="coin-text">{{ item.symbol }}</span>
                                </div>
                            </div>
                            <div class="cell-item">
                                <span>{{ formatNumber(item.contract_balance) }}</span>
                            </div>
                            <div class="cell-item">
                                <span>{{ formatNumber(parseFloat(item.contract_balance) - parseFloat(item.lock_contract)) }}</span>
                            </div>
                            <div class="cell-item">
                                <span>{{ formatNumber(item.lock_contract) }}</span>
                            </div>
                            <div class="cell-item">
                                <span>
                                    {{ $util.thousandSeparator(item.contract_balance * item.new_price, 2) }}
                                </span>
                            </div>
                            <div class="cell-item">
                                <a-button class="button-gray" @click="$router.push('/futures')">{{ $t('assets.trade') }}</a-button>
                                <a-button class="button-gray" @click="transfeShow = true">{{ $t('assets.transfer') }}</a-button>
                            </div>
                        </div>
                        <div class="flex align-center jus-end mt-20 pagination">
                            <a-pagination :total="pagination.total" show-total show-jumper @change="getList"/>
                        </div>
                    </div>
                    <not-date v-if="filteredList.length === 0" :height="500"></not-date>
                </div>
            </div>
            <div class="btm-right">
                <div class="btm-right-box">
                    <div class="_title">
                        <span>{{ $t('assets.asset_distribution') }}</span>
                    </div>
                    <div class="flex align-center">
                        <div>
                            <v-chart ref="chart" :option="chartOption" :autoresize="true" width="250px"
                                     height="250px" style="width: 250px; height: 250px;"></v-chart>
                        </div>
                    </div>
                </div>
                <div class="btm-right-box">
                    <div class="_title">
                        <span>{{ $t('assets.fund_flow') }}</span>
                        <span class="seeall">
                            {{ $t('assets.view_all') }}
                        </span>
                    </div>
                    <a-scrollbar class="_list">
                        <div class="_cell" v-for="(item,index) in logList" :key="'l'+item.id">
                            <div class="_item">
                                <span>{{types[item.type]}}</span>
                                <span>{{formatNumber(item.amount)}} {{item.currency.symbol}}</span>
                            </div>
                            <div class="_item">
                                <span>{{item.created_at}}</span>
                                <span class="color-primary">{{ $t('assets.completed') }}</span>
                            </div>
                        </div>
                    </a-scrollbar>
                    <not-date :height="300"></not-date>
                </div>
            </div>
        </div>
    </div>
    <!--    资金划转-->
    <funds-transfe :visible="transfeShow" @close="transfeShow = false"></funds-transfe>
    <!--    充值-->
    <up-trigget :visible="upShow" @close="upShow = false"></up-trigget>
    <!--     提现-->
    <withdraw-trgget :visible="withdrawShow" @click="withdrawShow = false"></withdraw-trgget>
</template>
<script>
import notDate from "@/components/notdate/notdate.vue";
import {mapGetters} from "vuex";

import VChart from 'vue-echarts';
import * as echarts from 'echarts/core';
import {
    PieChart
} from 'echarts/charts';
import {
    TooltipComponent,
    LegendComponent,
    TitleComponent
} from 'echarts/components';
import {
    CanvasRenderer
} from 'echarts/renderers';
import fundsTransfe from "@/components/fundsTransfe/fundsTransfe.vue";
import upTrigget from "@/components/topUp/topUp.vue";
import withdrawTrgget from "@/components/withdraw/withdraw.vue";
import userApi from "@/common/api/user";
echarts.use([PieChart, TooltipComponent, LegendComponent, CanvasRenderer,TitleComponent]);

export default {
    components: {withdrawTrgget, upTrigget, fundsTransfe, notDate,VChart},
    props: {
        balance: {
            type: Array,
            default: [],
        },
        total: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            transfeShow: false,
            upShow: false,
            withdrawShow: false,

            visual: false,
            checked: false,
            list: [],
            filteredList: [],
            searchKeyword: '',
            pagination: {
                total: 0,
                pageSize: 7
            },
            chartOption:{
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'var(--background-secondary)',
                    borderColor: 'var(--border-strength-200)',
                    textStyle: {
                        color: 'var(--content-primary)'
                    }
                },
                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    top:"top",
                    textStyle: {
                        color: 'var(--content-primary)',
                        fontSize: 12
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        label:{
                            show:false
                        },
                        center:['50%','50%'],
                        radius: '50%',
                        data: [
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.3)'
                            }
                        }
                    }
                ]
            },
            types:[],
            logList:[]
        }
    },
    computed:{
        ...mapGetters(['symbol','symbol_rate'])
    },
    mounted() {
        this.pagination.total = this.balance.length
        this.getList(1)
        this.filterData()
        this.getFundLogList();
        // 延迟更新图表，确保DOM完全渲染
        this.$nextTick(() => {
            setTimeout(() => {
                this.updateChart();
            }, 100);
        });
    },
    methods: {
        updateChart() {
            // 确保DOM元素存在且已渲染
            this.$nextTick(() => {
                var data = [];
                this.balance.map((item)=>{
                    if(item.contract_balance > 0){
                        data.push({
                            value:parseFloat(item.contract_balance),
                            name:item.symbol
                        });
                    }
                });
                this.chartOption['series'][0]['data'] = data;
                
                // 强制更新图表
                setTimeout(() => {
                    if (this.$refs.chart) {
                        this.$refs.chart.resize();
                    }
                }, 50);
            });
        },
        getFundLogList(){
            userApi.getCpitalFlow({
                account:3,
                start_at:"",
                end_at:"",
                currency_id:0,
                type:0,
                page:1
            }).then(res=>{
                console.log(res);
                let types = [];
                res.data.types.map((item)=>{
                    types[item.value] = item.label;
                });
                this.types = types;
                this.logList = res.data.list;
            })
        },
        checkboxChange(e) {
            this.checked = e;
            this.filterData();
        },
        handleSearch() {
            this.filterData();
        },
        filterData() {
            let filtered = this.balance;

            // 搜索过滤
            if (this.searchKeyword.trim()) {
                filtered = filtered.filter(item =>
                    item.symbol.toLowerCase().includes(this.searchKeyword.toLowerCase())
                );
            }

            // 隐藏0资产过滤 - 只隐藏合约账户余额为0的资产
            if (this.checked) {
                filtered = filtered.filter(item => parseFloat(item.contract_balance || 0) > 0);
            }

            // 按余额从高到低排序
            filtered.sort((a, b) => parseFloat(b.contract_balance || 0) - parseFloat(a.contract_balance || 0));

            this.filteredList = filtered;
            this.pagination.total = filtered.length;
            this.getList(1); // 重置到第一页
        },
        getList(c) {
            const startIndex = this.pagination.pageSize * (c - 1);
            const endIndex = startIndex + this.pagination.pageSize;
            this.list = this.filteredList.slice(startIndex, endIndex);
        },
        formatNumber(value) {
            if (!value || parseFloat(value) === 0) {
                return '0.00';
            }
            const num = parseFloat(value);
            // 去除末尾的0，但保留至少2位小数
            return num.toFixed(8).replace(/\.?0+$/, '').replace(/^(\d+\.\d{1})$/, '$10');
        },
    }
}
</script>
<style lang="scss" scoped>
@import "./futuresAccount.scss";
</style>
